import { allowedTitlesForOwnershipType } from "@/lib/formatters";

// Message for an owner title that ownerTypeConfirm (lib/formatters.ts)
// doesn't allow for the selected ownership type. Shared so every caller lists
// the allowed titles the same way.
export function ownerTitleMismatchMessage(ownershipTypeCd: string): string {
  const allowedTitles = allowedTitlesForOwnershipType(ownershipTypeCd.trim());
  const titles = allowedTitles.length
    ? allowedTitles.join(", ")
    : "(unknown ownership type)";
  return `Pick a title that matches the ownership type. Allowed: ${titles}.`;
}

// True only once BOTH fields hold a value and that pairing isn't one
// ownerTypeConfirm allows. Deliberately gated on "both non-blank": in a
// context where the owner section isn't required (send-intake's optional
// prefill, EditApplicationModal), a still-blank field is fine and shouldn't
// be flagged -- but a filled-in mismatched pair is wrong to send regardless
// of whether the fields were required. (The always-required operator-fills
// path enforces this differently -- see localValidate -- since there blank
// is itself invalid, not just unmatched.)
export function ownerTitleMismatch(
  ownershipTypeCd: string | undefined | null,
  title: string | undefined | null,
): boolean {
  const type = (ownershipTypeCd ?? "").trim();
  const t = (title ?? "").trim();
  return !!type && !!t && !allowedTitlesForOwnershipType(type).includes(t);
}
